import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "redux/store";

import { ICloudboxDataset } from "types/api/addonsApiInterface";

export const getCloudbox = (state: AppState) => state.cloudboxes;

export const getCloudboxNumber = createSelector(getCloudbox, (cloudbox) => {
 return cloudbox?.list.totalCount || 0;
});

export const getCloudboxConfigurator = createSelector(getCloudbox, (cloudbox) => {
 return cloudbox?.list.dataset.map((cloudbox: ICloudboxDataset) => {
  return {
   id: cloudbox.id,
   name: cloudbox.name,
   userid: cloudbox.userid,
   cloudbox_id: cloudbox.cloudbox_id,
   location: cloudbox.location,
   product: cloudbox.product,
   status: cloudbox.status
  };
 });
});

export const getCloudboxDataset = createSelector(getCloudbox, (cloudbox) => {
 return cloudbox?.list.dataset || [];
});

export const getSelectedCloudboxData = createSelector(getCloudbox, (cloudbox) => {
 return cloudbox?.selectedCloudbox;
});
